import { Plus, X, ImageIcon } from "lucide-react";
import { useDesign } from "../state/designStore";
import { MAX_TEXT_ITEMS } from "../types";

export function TextLayersBar() {
  const { design, activeTextId, activeLayerKind, setActiveTextId, addText, removeText } = useDesign();

  if (!design) return null;
  const { texts } = design;

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <label className="text-sm text-tg-hint">طبقات النص</label>
        <span className="text-xs text-tg-hint">
          {texts.length}/{MAX_TEXT_ITEMS}
        </span>
      </div>
      <div className="flex flex-wrap gap-2">
        {texts.map((t, i) => {
          const isActive = activeLayerKind === "text" && t.id === activeTextId;
          return (
            <div
              key={t.id}
              className={`flex items-center gap-1.5 rounded-full pl-1 pr-3 py-1.5 text-sm ${
                isActive ? "bg-tg-button text-tg-buttonText" : "glass-pill text-tg-text"
              }`}
            >
              <button type="button" onClick={() => setActiveTextId(t.id)} className="flex items-center gap-1.5 px-1">
                {t.is_icon ? (
                  <>
                    <ImageIcon size={14} strokeWidth={2.25} /> شعار
                  </>
                ) : t.text.trim() ? (
                  t.text.trim().slice(0, 10)
                ) : (
                  `نص ${i + 1}`
                )}
              </button>
              {texts.length > 1 && (
                <button
                  type="button"
                  onClick={() => removeText(t.id)}
                  aria-label="حذف هذه الطبقة"
                  className="w-5 h-5 rounded-full flex items-center justify-center opacity-70 hover:opacity-100"
                >
                  <X size={13} strokeWidth={2.5} />
                </button>
              )}
            </div>
          );
        })}

        {texts.length < MAX_TEXT_ITEMS && (
          <button
            type="button"
            onClick={addText}
            className="w-9 h-9 rounded-full glass-pill text-tg-link flex items-center justify-center"
            aria-label="إضافة نص جديد"
          >
            <Plus size={18} strokeWidth={2.5} />
          </button>
        )}
      </div>
    </div>
  );
}
